import type { EmbedConsentApi } from 't-lib-postviewer';
import type { EmbedService } from '../schema-copy/api-schema';
import { getJurisdiction } from '../connector/geo';
import { grantEmbedConsent } from '../connector/preferences';
import { isServingOfflineOnly } from '../connector/post-engine';

// The reader's embed consent, backed by preferences.embedConsent (the gating itself lives in
// t-lib-postviewer). Mirror of the preference, synced from App.tsx whenever preferences change,
// so the imperative post DOM pipeline can check consent without holding a preferences hook (same
// pattern as feed-name-overrides).
let consentPrefs: Partial<Record<EmbedService, boolean>>|undefined;

export function setEmbedConsentPrefs(prefs?: Partial<Record<EmbedService, boolean>>): void {
    consentPrefs = prefs;
}

/** Absent preference key means jurisdiction default: allowed for US, blocked for EU. */
export function isEmbedAllowed(service: EmbedService): boolean {
    return consentPrefs?.[service] ?? getJurisdiction() != 'EU';
}

export const persistentConsent: EmbedConsentApi = { isAllowed: isEmbedAllowed, grant: grantEmbedConsent };

/** Whether a service's vendor script may be loaded: consented, and not offline (posts rendered
 *  offline have no hydratable embeds, and the script couldn't load anyway). */
export function isEmbedScriptAllowed(service: EmbedService): boolean {
    return !isServingOfflineOnly() && isEmbedAllowed(service);
}
